var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_44852)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.8764H32V6.59179C32 4.35822 30.1894 2.54761 27.9558 2.54761H4.04419C1.81061 2.54761 0 4.35822 0 6.59179V15.8764ZM1.875 14.0014V6.59179C1.875 5.39375 2.84614 4.42261 4.04419 4.42261H27.9558C29.1539 4.42261 30.125 5.39375 30.125 6.59179V14.0014H1.875Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8125 14.9389H5.6875V12.155H26.3125V14.9389H28.1875V10.28H3.8125V14.9389Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.75 6.28811H12.25V8.16311H19.75V6.28811Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1875 6.28811H26.3125V8.16311H28.1875V6.28811Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87498 23.0734C1.87498 24.6245 3.13242 25.8818 4.68341 25.8818C6.23449 25.8818 7.49185 24.6245 7.49185 23.0734V17.784H5.61685V23.0734C5.61685 23.589 5.19896 24.0068 4.68341 24.0068C4.16791 24.0068 3.74998 23.5889 3.74998 23.0734V22.1359H1.87498V23.0734Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0648 26.5068V17.784H13.1898V26.5068H15.0648Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3193 24.0068C26.8038 24.0068 26.3859 23.589 26.3859 23.0734V17.784H24.5109V23.0734C24.5109 24.6245 25.7682 25.8818 27.3193 25.8818C28.8703 25.8818 30.1277 24.6245 30.1277 23.0734V22.1359H28.2527V23.0734C28.2527 23.5889 27.8348 24.0068 27.3193 24.0068Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1073 27.6101C23.2647 27.6101 22.5815 26.927 22.5815 26.0843V22.3547H20.7065V26.0843C20.7065 27.9625 22.2291 29.4851 24.1073 29.4851H25.0448V27.6101H24.1073Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95653 29.4851H7.89403C9.77223 29.4851 11.2948 27.9625 11.2948 26.0843V22.3547H9.41984V26.0843C9.41984 26.927 8.7367 27.6101 7.89403 27.6101H6.95653V29.4851Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8125 24.6318V17.784H16.9375V24.6318H18.8125Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_44852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.dc807fa8823a7a5b6b751f7643adac38.svg";
export { ForwardRef as ReactComponent };